export default {
  // 布局
  layout: {
    base: {},
  },
  // 页面
  page: {},
  // 组件
  component: {},
};
